import ApiService from '@/util/api.service';

const defaultState = () => ({
  groups: [],
  loaded: false,
  loading: false,
});

const getters = {
  visibleGroups: (state) => state.groups
    .filter((g) => g.enabled !== false)
    .slice()
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
      || (a.name || '').localeCompare(b.name || '')),
  isLoading: (state) => state.loading,
};

const actions = {
  async load({ commit, state }) {
    if (state.loaded || state.loading) return;
    commit('SET_LOADING', true);
    try {
      const groups = await ApiService({ url: '/v2/radio/groups', method: 'get' });
      commit('SET_GROUPS', Array.isArray(groups) ? groups : []);
      commit('SET_LOADED', true);
    } catch (err) {
      console.warn('radioGroups load failed', err);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  upsert({ commit }, group) {
    commit('UPSERT_GROUP', group);
  },
};

const mutations = {
  SET_GROUPS(state, list) { state.groups = list; },
  SET_LOADED(state, v) { state.loaded = v; },
  SET_LOADING(state, v) { state.loading = v; },
  UPSERT_GROUP(state, group) {
    const idx = state.groups.findIndex((g) => g._id === group._id);
    if (idx === -1) state.groups.push(group);
    else state.groups.splice(idx, 1, group);
  },
};

export default {
  namespaced: true,
  state() { return defaultState(); },
  getters,
  actions,
  mutations,
};
